import axiosInstance from "../utils/axios";

export const GetBrandColor = async (param) => {
  return await axiosInstance().get(`/getBrand`, {params:param});
};